import { useMutation, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';
import { uploadFile, UploadResponse, UploadOptions } from '../api/endpoints/upload';

export interface UseUploadFileOptions extends UseMutationOptions<UploadResponse, unknown, FormData, unknown> {
  onProgress?: UploadOptions['onProgress'];
}

export function useUploadFile(options?: UseUploadFileOptions): UseMutationResult<UploadResponse, unknown, FormData, unknown> {
  const { onProgress, ...mutationOptions } = options ?? {};
  return useMutation<UploadResponse, unknown, FormData>({
    mutationFn: (formData: FormData) => uploadFile(formData, { onProgress }),
    ...mutationOptions,
  });
}


